<app-draggable-modal-wrapper>
    <div class="grid grid-cols-12 ps-6 pt-2 mat-typography">
        <mat-dialog-content class="col-span-5">
            <h2 class="!text-2xl !font-normal !text-tertiary-900">
                Add Attachment:
            </h2>
            <div>
                <app-attachment-upload [form]="form"></app-attachment-upload>
            </div>
        </mat-dialog-content>
        <mat-dialog-content class="col-span-7">
            <h2 class="!text-2xl !font-normal !text-tertiary-900">
                Uploaded Files:
            </h2>
            <app-attachment-list
                [form]="form"
                [applicationId]="data.applicationId"
            ></app-attachment-list>
        </mat-dialog-content>
    </div>
    <mat-dialog-actions align="end" class="!p-5">
        <button
            type="button"
            mat-stroked-button
            mat-dialog-close
            color="primary"
            class="!border-primary-700"
        >
            Cancel
        </button>
        <button
            mat-raised-button
            mat-dialog-close
            type="button"
            (click)="onSave()"
            [disabled]="!canSave()"
            name="Save"
            cdkFocusInitial
            color="primary"
        >
            Save and Return to Application
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
